import { Component, Input } from '@angular/core';
import { ApColorSelectorService } from '../../../shared/index';
import { ApBaseComponent } from 'webcommon/core-ui';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'ap-fc-text-color-list',
  templateUrl: './fc-text-color-list.component.html',
  styleUrls: ['./fc-text-color-list.component.less']
})
export class FcTextColorListComponent extends ApBaseComponent {
  @Input() baseId: string;
  @Input() form: FormGroup;
  @Input() textColorControl: FormControl;
  @Input() textColorValue: string;
  @Input() color: string;

  constructor(public apColorSelectorService: ApColorSelectorService) {
    super();
  }

  public showColorSelectorModal(): void {
    this.apColorSelectorService.openModal(this.baseId, this.color)
      .then((res) => {
        if (res) {
          this.textColorControl.markAsDirty();
        }
      });
  }
}
